module.exports = {
  version: '1.1.0',
  core: {
    requiredMappings: [{
      name: 'page',
      sourceValue: 'schema',
      defaultValue: 'iglu:au.com.realestate/page/jsonschema/1-0-0'
    }]
  },
  systems: {
    'property-listings-web': {
      'rea:buy:details': {
        requiredMappings: [{
          name: 'listing',
          sourceValue: 'schema',
          defaultValue: 'iglu:au.com.realestate/listing/jsonschema/5-0-0'
        }, {
          name: 'property',
          sourceValue: 'schema',
          defaultValue: 'iglu:au.com.realestate/property/jsonschema/3-0-0'
        }],
        staticMappings: {
          posttags: 'buyx'
        }
      },
      'rea:sold:details': {
        requiredMappings: [{
          name: 'listing',
          sourceValue: 'schema',
          defaultValue: 'iglu:au.com.realestate/listing/jsonschema/5-0-0'
        }, {
          name: 'property',
          sourceValue: 'schema',
          defaultValue: 'iglu:au.com.realestate/property/jsonschema/3-0-0'
        }],
        staticMappings: {
          posttags: 'soldx'
        }
      },
      'rea:sold:resultslist': {
        requiredMappings: [{
          name: 'first_search_result',
          sourceValue: 'schema',
          defaultValue: 'iglu:au.com.realestate/first_search_result/jsonschema/3-0-0'
        }, {
          name: 'listing_search_parameters',
          sourceValue: 'schema',
          defaultValue: 'iglu:au.com.realestate/listing_search_parameters/jsonschema/1-0-0'
        }],
        staticMappings: {
          posttags: 'soldx'
        }
      },
      'rea:buy:resultslist': {
        requiredMappings: [{
          name: 'first_search_result',
          sourceValue: 'schema',
          defaultValue: 'iglu:au.com.realestate/first_search_result/jsonschema/3-0-0'
        }, {
          name: 'listing_search_parameters',
          sourceValue: 'schema',
          defaultValue: 'iglu:au.com.realestate/listing_search_parameters/jsonschema/1-0-0'
        }],
        staticMappings: {
          posttags: 'buyx'
        }
      },
      'rea:buy:salesofi': {
        requiredMappings: [{
          name: 'first_search_result',
          sourceValue: 'schema',
          defaultValue: 'iglu:au.com.realestate/first_search_result/jsonschema/3-0-0'
        }, {
          name: 'listing_search_parameters',
          sourceValue: 'schema',
          defaultValue: 'iglu:au.com.realestate/listing_search_parameters/jsonschema/1-0-0'
        }],
        staticMappings: {
          posttags: 'inspectionx'
        }
      },
      'rea:rent:resultslist': {
        requiredMappings: [{
          name: 'first_search_result',
          sourceValue: 'schema',
          defaultValue: 'iglu:au.com.realestate/first_search_result/jsonschema/3-0-0'
        }, {
          name: 'listing_search_parameters',
          sourceValue: 'schema',
          defaultValue: 'iglu:au.com.realestate/listing_search_parameters/jsonschema/1-0-0'
        }],
        staticMappings: {
          posttags: 'rentx'
        }
      },
      'rea:rent:details': {
        requiredMappings: [{
          name: 'listing',
          sourceValue: 'schema',
          defaultValue: 'iglu:au.com.realestate/listing/jsonschema/5-0-0'
        }, {
          name: 'property',
          sourceValue: 'schema',
          defaultValue: 'iglu:au.com.realestate/property/jsonschema/3-0-0'
        }],
        staticMappings: {
          posttags: 'rentx'
        }
      }
    },
    'rea-desktop-homepage': {
      'rea:sold:homepage': {
        requiredMappings: [{
          name: 'listing',
          sourceValue: 'schema',
          defaultValue: 'iglu:au.com.realestate/listing/jsonschema/1-0-1'
        }, {
          name: 'listing_search_parameters',
          sourceValue: 'schema',
          defaultValue: 'iglu:au.com.realestate/listing_search_parameters/jsonschema/1-0-0'
        }]
      }
    },
    'consumer-search': {
      'rea:agent:resultslist': {
        requiredMappings: [{
          name: 'page',
          sourceValue: 'schema',
          defaultValue: 'iglu:au.com.realestate/page/jsonschema/2-0-9'
        }, {
          name: 'agency_search_parameters_data',
          sourceValue: 'schema',
          defaultValue: 'iglu:au.com.realestate/agency_search_parameters_data/jsonschema/1-1-0'
        }]
      }
    }
  },
  dataLayerSchemaMappings: {
    'iglu:au.com.realestate/page/jsonschema/1-0-0': {
      mappings: {
        site: 'page.data.site',
        platform: {
          sourceValue: 'page.data.responsive_layout',
          defaultValue: 'web',
          transforms: [{
            type: 'replace',
            map: {
              XL: 'web',
              L: 'web',
              M: 'midi',
              S: 'msite'
            }
          }]
        },
        channel: 'page.data.site_section',
        sect: {
          sourceValue: 'page.data.page_type',
          transforms: [{
            type: 'replace',
            map: {
              'search result - list': 'resultslist',
              'search result - ofi': 'salesofi',
              'property details': 'details',
              'search results - list': 'resultslist'
            }
          }]
        }
      }
    },
    'iglu:au.com.realestate/page/jsonschema/2-0-9': {
      inherit: 'iglu:au.com.realestate/page/jsonschema/1-0-0',
      mappings: {
        platform: {
          sourceValue: 'page.data.platform'
        },
        channel: {
          sourceValue: 'page.data.site_section',
          transforms: [{
            type: 'replace',
            map: {
              'find agent': 'agent'
            }
          }]
        }
      }
    },
    'iglu:au.com.realestate/agency_search_parameters_data/jsonschema/1-1-0': {
      mappings: {
        sub: {
          sourceValue: 'agency_search_parameters_data.data.suburb',
          transforms: [{
            type: 'lowercase'
          }, {
            type: 'regex',
            pattern: '[^a-z]*',
            replaceWith: ''
          }]
        },
        state: {
          sourceValue: 'agency_search_parameters_data.data.state',
          transforms: [{
            type: 'lowercase'
          }]
        },
        pcode: 'agency_search_parameters_data.data.postcode',
        cat: {
          sourceValue: 'agency_search_parameters_data.data.channel',
          transforms: [{
            type: 'replace',
            map: {
              Buy: 'selling',
              Rent: 'leasing'
            }
          }]
        }
      }
    },
    'iglu:au.com.realestate/listing_search_parameters/jsonschema/1-0-0': {
      mappings: {
        bedmin: {
          sourceValue: 'listing_search_parameters.data.bedrooms_min',
          defaultValue: '-1',
          transforms: [{
            type: 'replace',
            map: {
              studio: '0'
            }
          }]
        },
        bedmax: {
          sourceValue: 'listing_search_parameters.data.bedrooms_max',
          defaultValue: '-1',
          transforms: [{
            type: 'replace',
            map: {
              studio: '0'
            }
          }]
        }
      }
    },
    'iglu:au.com.realestate/listing/jsonschema/1-0-1': {
      mappings: {
        agent: {
          sourceValue: 'listing.data.agency_id',
          transforms: [{
            type: 'lowercase'
          }]
        },
        price: {
          sourceValue: 'listing.data.price_range',
          transforms: [{
            type: 'lowercase'
          }]
        },
        constructionstatus: 'listing.data.construction_status'
      }
    },
    'iglu:au.com.realestate/listing/jsonschema/2-0-0': {
      inherit: 'iglu:au.com.realestate/listing/jsonschema/1-0-1',
      mappings: {
        price: {
          sourceValue: 'listing.data.marketing_price_range',
          transforms: [{
            type: 'lowercase'
          }]
        }
      }
    },
    'iglu:au.com.realestate/listing/jsonschema/5-0-0': {
      inherit: 'iglu:au.com.realestate/listing/jsonschema/2-0-0',
      mappings: {
        productDepth: 'listing.data.product_depth'
      }
    },
    'iglu:au.com.realestate/property/jsonschema/2-0-1': {
      mappings: {
        sub: {
          sourceValue: 'property.data.suburb',
          transforms: [{
            type: 'lowercase'
          }, {
            type: 'regex',
            pattern: '[^a-z]*',
            replaceWith: ''
          }]
        },
        state: {
          sourceValue: 'property.data.state',
          transforms: [{
            type: 'lowercase'
          }]
        },
        pcode: 'property.data.postcode',
        beds: 'property.data.bedrooms',
        baths: 'property.data.bathrooms',
        cars: 'property.data.car_spaces',
        proptype: 'property.data.property_type',
        region: 'property.data.region'
      }
    },
    'iglu:au.com.realestate/property/jsonschema/3-0-0': {
      inherit: 'iglu:au.com.realestate/property/jsonschema/2-0-1',
      mappings: {
        region: 'property.data.marketing_region'
      }
    },
    'iglu:au.com.realestate/first_search_result/jsonschema/1-0-1': {
      mappings: {
        agent: {
          sourceValue: 'first_search_result.data.agency_id',
          transforms: [{
            type: 'lowercase'
          }]
        },
        sub: {
          sourceValue: 'first_search_result.data.suburb',
          transforms: [{
            type: 'lowercase'
          }, {
            type: 'regex',
            pattern: '[^a-z]*',
            replaceWith: ''
          }]
        },
        state: {
          sourceValue: 'first_search_result.data.state',
          transforms: [{
            type: 'lowercase'
          }]
        },
        price: {
          sourceValue: 'first_search_result.data.price_range',
          transforms: [{
            type: 'lowercase'
          }]
        },
        beds: 'first_search_result.data.bedrooms',
        baths: 'first_search_result.data.bathrooms',
        cars: 'first_search_result.data.car_spaces',
        constructionstatus: 'first_search_result.data.construction_status',
        proptype: 'first_search_result.data.property_type',
        region: 'first_search_result.data.region',
        pcode: 'first_search_result.data.postcode'
      }
    },
    'iglu:au.com.realestate/first_search_result/jsonschema/3-0-0': {
      inherit: 'iglu:au.com.realestate/first_search_result/jsonschema/1-0-1',
      mappings: {
        region: 'first_search_result.data.marketing_region',
        price: {
          sourceValue: 'first_search_result.data.marketing_price_range',
          transforms: [{
            type: 'lowercase'
          }]
        }
      }
    }
  }
};
//# sourceMappingURL=mapping.js.map